export const zoomIn = (state) => {
  throw new Error('not implemented')
}
